import React, { useState } from 'react';
import { Header } from '../../Components/Header';
import './style.css';
import ContactTestimonialCarousel from '../../Components/contact/ContactTestimonialCarousel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import Button from '../../Components/ui/button/Button';
import { Footer } from '../../Components/Footer';
import { useNavigate } from 'react-router-dom';
import ApplyAsTutorPopup from '../../Components/apply-as-tutor/ApplyAsTutorPopup';
import CustomModal from '../../Components/CustomModal';
import OrangeButton from '../../Components/buttons/orange-button';
import DownloadPopup from '../tutor-details/components/DownloadPopup';
import HeaderAlt from '../../Components/HeaderAlt';

const ApplyAsVIP = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);

  const feature = [
    {
      id: 1,
      title: 'Set your own rate',
      desc: 'Choose your hourly rate and change it anytime. On average, English tutors charge $15-25 per hour.',
      imgUrl: '/images/icons/dollarsign.svg',
    },
    {
      id: 2,
      title: 'Teach from anywhere',
      desc: 'Decide when and how many hours you want to teach. No minimum time commitment or fixed schedule.',
      imgUrl: '/images/icons/globe.svg',
    },
    {
      id: 3,
      title: 'Grow professionally',
      desc: 'Attend professional development webinars and get tips to upgrade your skills. You’ll get all the help you need from our team.',
      imgUrl: '/images/icons/ChartLine.png',
    },
  ];

  const faqData = [
    {
      que: 'What subjects can I teach?',
      ans: 'We have over 100 subjects on IAMAI, including languages, school and university subjects, hobbies and art.',
    },
    {
      que: 'How do I become an online tutor?',
      ans: 'We have over 100 subjects on IAMAI, including languages, school and university subjects, hobbies and art.',
    },
    {
      que: 'How can I get my profile approved quickly?',
      ans: 'We have over 100 subjects on IAMAI, including languages, school and university subjects, hobbies and art.',
    },
    {
      que: 'Why should I choose IAMAI?',
      ans: 'We have over 100 subjects on IAMAI, including languages, school and university subjects, hobbies and art.',
    },
    {
      que: 'What computer equipment do I need to teach?',
      ans: 'We have over 100 subjects on IAMAI, including languages, school and university subjects, hobbies and art.',
    },
  ];
  return (
    <div>
      <HeaderAlt />
      <div className="rounded-bl-[16px] rounded-br-[16px] bg-[#66CDCC] py-8 md:pb-16 md:pt-[80px]">
        <div className="container flex w-full flex-col items-center justify-between gap-10 lg:flex-row">
          <div className="max-w-[626px] flex-1">
            <h1 className="hero-title fredokaOne w-full !text-[40px]  !font-normal leading-normal tracking-[-0.8px] !text-greenColor md:!text-[56px] md:tracking-[-1.12px]">
              Take Just 15 Minutes to Supercharge Your Teaching Like Never Before!
            </h1>

            <div className="relative mt-10">
              <div className="hidden md:block">
                <div className="max-w-[80%] border-t-2 border-dashed border-yellow-300"></div>
                <div className="absolute -top-[17px] flex w-full justify-between">
                  <div>
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200 text-lg font-bold">
                      1
                    </div>
                    <h4 className="mt-2 text-base font-medium">Sign Up</h4>
                    <p className="text-sm text-gray-700">and create your profile</p>
                  </div>
                  <div className="mr-10">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200 text-lg font-bold">
                      2
                    </div>
                    <h4 className="mt-2 text-base font-medium">Get Approved</h4>
                    <p className="text-sm text-gray-700">within 5 days</p>
                  </div>
                  <div>
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200 text-lg font-bold">
                      3
                    </div>
                    <h4 className="mt-2 text-base font-medium">Start Earning</h4>
                    <p className="text-sm text-gray-700">and start teaching</p>
                  </div>
                </div>
              </div>

              <div className="relative block md:hidden">
                <div className="absolute left-5 top-10 h-[75%] border-l-2 border-dashed border-yellow-300"></div>
                <div className="flex flex-col items-start space-y-8 ">
                  <div className="flex items-center ">
                    <div className="z-10 flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200 text-lg font-bold">
                      1
                    </div>
                    <div className="ml-4">
                      <h4 className="text-base font-medium">Sign Up</h4>
                      <p className="text-sm text-gray-700">and create your profile</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="z-10 flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200 text-lg font-bold">
                      2
                    </div>
                    <div className="ml-4">
                      <h4 className="text-base font-medium">Get Approved</h4>
                      <p className="text-sm text-gray-700">within 5 days</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="z-10 flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200 text-lg font-bold">
                      3
                    </div>
                    <div className="ml-4">
                      <h4 className="text-base font-medium">Start Earning</h4>
                      <p className="text-sm text-gray-700">and start teaching</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-12 max-w-sm lg:mt-32">
              <button
                onClick={() => setShowModal(true)}
                className="p-[8px 24px] fredoka flex h-[48px] w-full flex-shrink-0 items-center justify-center gap-[8px] rounded-[16px] bg-white font-semibold shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)_inset,0px_4px_4px_0px_rgba(255,255,255,0.35)_inset]"
              >
                Apply as Tutor
              </button>
            </div>
          </div>
          <div className="flex-1">
            <img src="/images/apply-as-tutor/hero-advisor.png" alt="" />
          </div>
        </div>
        {/* <ApplyAsTutorModal open={showModal} handleClose={() => setShowModal(false)} /> */}
        <CustomModal
          className="max-w-[480px]"
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        >
          <ApplyAsTutorPopup setShowModal={setShowModal} />
        </CustomModal>
      </div>
      <div className="container mt-16 max-w-5xl text-left space-y-6">
        <h1 className="fredokaOne text-[32px] md:text-[40px] text-greenColor tracking-[-0.8px] leading-tight">
          Act Quickly and Join IAMAI's Exclusive List of VIP Educators
        </h1>
        <p className="text-[18px] md:text-[22px] text-[#678285] tracking-[-0.22px] leading-relaxed">
          For a limited time, IAMAI will reward our earliest user signups with VIP status. Unlike regular educators, our VIP educators receive dedicated, personalized support. As new IAMAI features are introduced, VIPs gain early access to preview these new releases first (customizable in settings). You'll have a dedicated IAMAI account manager who personally supports your experience, providing manual assistance and custom workarounds whenever necessary. If your account manager isn't immediately available, you can message IAMAI’s engineering team or speak directly to our Customer Service representatives, available live from 9 am-6 pm US Central Time.
        </p>
      </div>

      <div className="container !mt-6 md:!mt-14 ">
        <div className="mx-auto mb-6 flex max-w-[772px] flex-col items-center justify-center space-y-6 px-2 md:mb-8 md:px-0">
          <h1 className="fredokaOne  text-center text-[32px] font-normal leading-tight tracking-[-0.8px] text-greenColor md:text-left md:text-[40px]">
            All-in-One Tutor Management System
          </h1>
          <p className="fredoka text-centertext-[18px] font-normal leading-[145.55%] tracking-[-0.18px] text-[#678285] md:text-[22px]    md:tracking-[-0.22px] ">
            Manage students, schedule sessions, and generate AI-powered study materials with ease.
            Tutor CRM streamlines communication, tracks progress, and provides AI-driven insights to
            enhance learning. Stay organized, optimize teaching, and help students achieve their
            academic goals—all in one place.
          </p>
          <OrangeButton
            className="fredokaOne !h-12 !rounded-2xl"
            onClick={() => navigate('/tutor-crm')}
            label={'Explore Tutor CRM'}
          />
        </div>
        <div className="flex justify-center ">
          <img src="/images/apply-as-tutor/students-management.png" alt="" />
        </div>
      </div>
      <div className="container !mt-[104px]">
        <div className="flex flex-col-reverse items-center justify-center gap-9 md:flex-row md:gap-[79px]">
          <div>
            <img src="/images/apply-as-tutor/handbook.png" alt="" />
          </div>
          <div className="flex max-w-[606px] flex-col gap-6 ">
            <h1 className="fredokaOne  text-center text-[32px] font-normal leading-tight tracking-[-0.8px] text-greenColor md:text-left md:text-[40px]">
              Tutor Success Handbook
            </h1>
            <p className="fredoka text-centertext-[18px] font-normal leading-[145.55%] tracking-[-0.18px] text-[#678285] md:text-[22px]    md:tracking-[-0.22px]">
              Unlock the secrets to becoming a top tutor with our Tutor Success Handbook—a complete
              guide packed with expert strategies, AI-powered teaching tools, and proven methods to
              enhance student learning. Learn how to streamline lesson planning, track progress
              efficiently, and engage students effectively using our platform&apos;s advanced
              features. Whether you&apos;re new to tutoring or an experienced educator, this
              handbook will help you elevate your teaching, save time, and boost student success.
              Download your free copy today and take your tutoring to the next level!
            </p>
            <OrangeButton
              className="fredokaOne !h-12 !rounded-2xl md:!w-fit"
              onClick={() => setShowDownloadModal(true)}
              label={'Download Handbook'}
            />
          </div>
        </div>
      </div>
      <div className="container !relative !my-14">
        <ContactTestimonialCarousel showTitle={false} />
        <div className="mx-auto max-w-[400px]  ">
          <button
            onClick={() => setShowModal(true)}
            className={`fredoka mt-8 w-full rounded-[16px] bg-[#FC823E] px-4 py-[10px] font-semibold text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] md:mt-0 `}
          >
            Apply as Tutor
          </button>
          <div className="mx-auto max-w-sm md:mx-0 lg:absolute lg:-bottom-24 lg:right-20">
            <img
              src="/images/apply-as-tutor/hurry-up-tutor.png"
              className="hidden md:block"
              alt=""
            />
            <img
              src="/images/apply-as-tutor/hurry-up-tutor3.png"
              className="mt-4 block md:hidden"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="!mt-28 bg-[#F7F7F7] py-[56px]">
        <div className="container !mx-auto md:!max-w-3xl">
          <h1 className=" fredokaOne mx-auto max-w-[398px] text-center text-[32px] font-normal leading-tight tracking-[-0.8px] text-greenColor md:text-left md:text-[40px]">
            Frequently Asked Questions
          </h1>
          <Box sx={{ marginTop: '40px' }}>
            {faqData.map((faq, index) => (
              <Accordion key={index} sx={{ backgroundColor: '#F7F7F7', boxShadow: 'none' }}>
                <AccordionSummary
                  fontFamily="fredoka"
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ fontWeight: 'normal', color: '#003b47', fontSize: '22px' }}
                >
                  {faq.que}
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    fontFamily="fredoka"
                    fontWeight="400"
                    variant="body2"
                    sx={{ color: '#4a4a4a', fontSize: '18px' }}
                  >
                    {faq.ans}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </div>
      </div>
      <div className="container mx-auto !mt-14 flex !max-w-[606px] flex-col items-center gap-[14px]  ">
        <p className="text-center text-[22px] font-medium leading-[32px] tracking-[-0.22px] text-greenColor">
          🤝 Join us
        </p>
        <h1 className="fredokaOne text-center text-[32px] font-normal leading-normal tracking-[-0.8px] text-[#012E33] md:text-left md:text-[40px]">
          Want to join our team?
        </h1>
        <p className="text-center text-[18px] font-normal leading-normal tracking-[-0.18px] text-[#678285] md:text-[22px] md:leading-[145.55%] md:tracking-[-0.22px]">
          If you are interested in joining our advisory board, we would love to hear from you.
        </p>
        <div className="w-full px-4 md:max-w-[300px]">
          <Button
            className="!w-[240px] !px-6 !py-2"
            onClick={() => navigate('/careers')}
            label={'See All Open Positions'}
          />
        </div>
      </div>
      <div className="px-4 lg:px-0">
        <div className="container relative !my-14 flex flex-col justify-between rounded-[56px] bg-[#66CDCC] !p-5 px-4 lg:!h-[500px] lg:flex-row lg:!p-16">
          <div className="mx-auto max-w-lg space-y-4 lg:mx-0">
            <h1 className="fredokaOne text-center text-[32px] font-normal leading-tight tracking-[-0.64px] text-[#012E33] md:tracking-[-0.8px] lg:text-left lg:text-[40px]">
              Turn your expertise into Income by teaching students
            </h1>
            <button
              onClick={() => setShowModal(true)}
              className="w-full rounded-[16px] bg-white px-6 py-2 font-semibold lg:w-fit"
            >
              Apply as Tutor
            </button>
            <div className="mx-auto max-w-sm lg:mx-0">
              <img
                src="/images/apply-as-tutor/hurry_up_tutor.png"
                className="hidden lg:ml-12 lg:block"
                alt="hurryup"
              />
              <img
                src="/images/apply-as-tutor/hurry-up-tutor2.png"
                alt="hurryup"
                className="block lg:hidden"
              />
            </div>
          </div>
          <div className="bottom-0 right-0 m-auto flex-1 lg:absolute lg:-top-20 lg:m-0 lg:max-w-lg">
            <img
              src="/images/apply-as-tutor/apply-as-tutor-img1.png"
              alt=""
              className="hidden lg:block"
            />
            <img src="/images/apply-as-tutor/tutors-small.png" alt="" className="block lg:hidden" />
          </div>
        </div>
      </div>
      <Footer />
      <CustomModal
        className="max-w-[480px]"
        isOpen={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
        isX={false}
      >
        <DownloadPopup setShowDownloadModal={setShowDownloadModal} />
      </CustomModal>
    </div>
  );
};

export default ApplyAsVIP;
